export default "__VITE_ASSET__BXiCj96x__"